/**
 * Application configuration
 */

export const appConfig = {
  app: {
    name: 'Property Tax Management Portal',
    municipalCorporation: 'Thane Municipal Corporation',
    municipalCorporationShort: 'Thane Municipal Corporation',
    description: 'Thane Municipal Corporation - Assessment Optimization',
    version: '1.0.0',
    env: process.env.NEXT_PUBLIC_APP_ENV || 'development',
  },
  api: {
    /** @deprecated Prefer `getApiBaseUrl()` from `@/lib/api/api-base-url` (browser uses /api-backend proxy when env unset). */
    baseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || (process.env.NEXT_PUBLIC_BACKEND_URL ? `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/` : 'https://automationdashboardbackend.scipl.info.in/api/'),
    // Global timeout for all APIs (3 minutes) to support slower endpoints.
    timeout: 180000,
  },
  auth: {
    enabled: process.env.NEXT_PUBLIC_AUTH_ENABLED === 'true',
    tokenKey: 'auth_token',
    refreshTokenKey: 'refresh_token',
  },
  features: {
    analytics: process.env.NEXT_PUBLIC_FEATURE_ANALYTICS === 'true',
    debug: process.env.NEXT_PUBLIC_FEATURE_DEBUG === 'true',
    useStandardAreaUseMapping: process.env.NEXT_PUBLIC_USE_STANDARD_AREA_USE_MAPPING?.toLowerCase() === 'true',
  },
} as const;

export type AppConfig = typeof appConfig;



